import { Action } from 'redux';

import { ISessionInfo } from '../../ts/ServerApi/types/ISessionInfo';
import { RefreshSessionInfo } from './AppActionTypes';
import { isActionFactory } from './isActionFactory';

export interface RefreshSessionInfoAction extends Action {
  sessionInfo: ISessionInfo;
}

export function refreshSessionInfo(sessionInfo: ISessionInfo): RefreshSessionInfoAction {
  return {
    type: RefreshSessionInfo,
    sessionInfo
  };
}
export const isRefreshSessionInfoAction = isActionFactory<RefreshSessionInfoAction>(RefreshSessionInfo);
